"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _index = require("../../InputSearch/index");

var _index2 = _interopRequireDefault(_index);

var _constants = require("../constants");

var _context = require("./context");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var InputSearch = function InputSearch(props) {
  var _useToolbarContext = (0, _context.useToolbarContext)(),
      testId = _useToolbarContext.testId;

  return _react2.default.createElement("div", {
    id: _constants.NAMESPACES.TOOLBAR.INPUT_SEARCH,
    "data-testid": testId + "__search-form",
    className: _constants.ORDER_CLASSNAMES.TOOLBAR_CHILD.INPUT
  }, _react2.default.createElement(_index2.default, _extends({
    testId: testId + "__search-form__input"
  }, props)));
};

exports.default = InputSearch;